module.exports = __webpack_public_path__ + "img/923.06188b2c.gif";